import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'

import { initSocket, socket } from '../utilies/config'
import { get_my_support_tickets, get_support_ticket } from '../store/reducers/supportReducer'
import { fetch_unread_count } from '../store/reducers/notificationReducer'

const SUPPORT_LIST_PATH = '/support/tickets'

const toastTitle = {
    'customer:support:admin_reply': 'Dəstək cavab verdi',
    'customer:support:ticket_status_changed': 'Müraciət yeniləndi'
}

const getDetailId = (pathname) => {
    if (!pathname.startsWith(`${SUPPORT_LIST_PATH}/`)) return ''
    const next = pathname.slice(SUPPORT_LIST_PATH.length + 1).split('/')[0]
    return next === 'create' ? '' : next
}

const SupportRealtimeListener = () => {
    const dispatch = useDispatch()
    const { pathname } = useLocation()
    const { userInfo } = useSelector(state => state.auth)

    useEffect(() => {
        const userId = userInfo?.id || userInfo?._id
        if (!userId) return undefined

        const sock = initSocket()
        const registerPresence = () => sock.emit('add_user', userId, userInfo)
        if (sock.connected) registerPresence()
        else sock.once('connect', registerPresence)

        const refreshSupport = (payload = {}) => {
            if (pathname === SUPPORT_LIST_PATH) {
                dispatch(get_my_support_tickets())
            } else {
                const detailId = getDetailId(pathname)
                if (detailId && payload.ticketId && detailId === payload.ticketId) {
                    dispatch(get_support_ticket(payload.ticketId))
                }
            }
            dispatch(fetch_unread_count())
        }

        const handlers = Object.keys(toastTitle).map(eventName => {
            const handler = (payload = {}) => {
                const suffix = payload.ticketNo ? `: ${payload.ticketNo}` : ''
                toast.success(`${toastTitle[eventName]}${suffix}`)
                refreshSupport(payload)
            }
            socket.on(eventName, handler)
            return [eventName, handler]
        })

        return () => {
            sock.off('connect', registerPresence)
            handlers.forEach(([eventName, handler]) => socket.off(eventName, handler))
        }
    }, [dispatch, pathname, userInfo])

    return null
}

export default SupportRealtimeListener
